import { useState } from "react";
import { Container, Button, Form, Card, Alert } from "react-bootstrap";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { validatePassword } from "../utils/passwordValidation.js";

export default function Register() {
  const navigate = useNavigate();
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [passwordValidation, setPasswordValidation] = useState({ isValid: false, hasLength: false, hasSpecial: false });
  const [passwordsMatch, setPasswordsMatch] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    setSuccess(false);
    
    const email = e.target.email.value;
    const password = e.target.password.value;
    const confirmPassword = e.target.confirmPassword.value;

    // Validate password
    const passwordValidation = validatePassword(password);
    if (!passwordValidation.isValid) {
      setError(passwordValidation.message);
      return;
    }

    if (password !== confirmPassword) {
      setError("Passwords do not match");
      return;
    }

    try {
      await axios.post("/api/auth/register", { email, password });
      setSuccess(true);
      setTimeout(() => {
        navigate("/login");
      }, 2000);
    } catch (err) {
      setError(err.response?.data?.message || "Registration failed");
    }
  };

  return (
    <Container style={{ minHeight: "80vh" }} className="d-flex justify-content-center align-items-center py-5">
      <Card className="brutal-card" style={{ width: 450, maxWidth: "100%" }}>
        <Card.Body className="p-5">
          <h2 className="brutal-heading text-center mb-4" style={{ fontSize: "36px" }}>
            REGISTER
          </h2>

          {error && <Alert variant="danger" className="brutal-alert mb-3">{error.toUpperCase()}</Alert>}
          {success && <Alert variant="success" className="brutal-alert mb-3">CHECK YOUR EMAIL TO VERIFY (If you don’t see it, please check your spam or junk folder. If it’s still missing, feel free to email us.)</Alert>}

          <Form onSubmit={handleSubmit}>
            <Form.Control
              name="email"
              type="email"
              placeholder="EMAIL"
              className="brutal-form-control mb-3"
              required
            />
            
            <Form.Group className="mb-3">
              <div className="position-relative">
                <Form.Control
                  name="password"
                  type="password"
                  value={password}
                  onChange={(e) => {
                    const pwd = e.target.value;
                    setPassword(pwd);
                    const validation = validatePassword(pwd);
                    setPasswordValidation({
                      isValid: validation.isValid,
                      hasLength: pwd.length >= 8,
                      hasSpecial: /[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]/.test(pwd),
                    });
                    if (confirmPassword) {
                      setPasswordsMatch(pwd === confirmPassword);
                    }
                  }}
                  placeholder="PASSWORD (MIN 8 CHARS, 1 SPECIAL CHAR)"
                  className="brutal-form-control"
                  required
                  minLength={8}
                  style={{
                    borderColor: password ? (passwordValidation.isValid ? "#00FF00" : "#FF0000") : undefined,
                    borderWidth: password ? "3px" : undefined,
                  }}
                />
                {password && (
                  <span
                    style={{
                      position: "absolute",
                      right: "15px",
                      top: "50%",
                      transform: "translateY(-50%)",
                      fontSize: "20px",
                      fontWeight: "900",
                    }}
                  >
                    {passwordValidation.isValid ? "✓" : "✗"}
                  </span>
                )}
              </div>
              {password && (
                <div className="mt-2" style={{ fontSize: "12px" }}>
                  <div style={{ color: passwordValidation.hasLength ? "#00FF00" : "#FF0000", fontWeight: "700" }}>
                    {passwordValidation.hasLength ? "✓" : "✗"} AT LEAST 8 CHARACTERS
                  </div>
                  <div style={{ color: passwordValidation.hasSpecial ? "#00FF00" : "#FF0000", fontWeight: "700" }}>
                    {passwordValidation.hasSpecial ? "✓" : "✗"} AT LEAST 1 SPECIAL CHARACTER
                  </div>
                </div>
              )}
            </Form.Group>

            <Form.Group className="mb-4">
              <div className="position-relative">
                <Form.Control
                  name="confirmPassword"
                  type="password"
                  value={confirmPassword}
                  onChange={(e) => {
                    const pwd = e.target.value;
                    setConfirmPassword(pwd);
                    setPasswordsMatch(password && pwd === password);
                  }}
                  placeholder="CONFIRM PASSWORD"
                  className="brutal-form-control"
                  required
                  minLength={8}
                  style={{
                    borderColor: confirmPassword ? (passwordsMatch ? "#00FF00" : "#FF0000") : undefined,
                    borderWidth: confirmPassword ? "3px" : undefined,
                  }}
                />
                {confirmPassword && (
                  <span
                    style={{
                      position: "absolute",
                      right: "15px",
                      top: "50%",
                      transform: "translateY(-50%)",
                      fontSize: "20px",
                      fontWeight: "900",
                    }}
                  >
                    {passwordsMatch ? "✓" : "✗"}
                  </span>
                )}
              </div>
              {confirmPassword && (
                <div className="mt-2" style={{ fontSize: "12px", fontWeight: "700", color: passwordsMatch ? "#00FF00" : "#FF0000" }}>
                  {passwordsMatch ? "✓ PASSWORDS MATCH" : "✗ PASSWORDS DO NOT MATCH"}
                </div>
              )}
            </Form.Group>

            <Button
              type="submit"
              className="brutal-btn brutal-btn-success w-100 mb-4"
              disabled={!passwordValidation.isValid || !passwordsMatch || !password || !confirmPassword}
            >
              CREATE ACCOUNT
            </Button>
          </Form>

          <div className="text-center">
            <Button
              variant="link"
              className="brutal-link p-0"
              onClick={() => navigate("/login")}
              style={{ textDecoration: "underline", textDecorationThickness: "2px" }}
            >
              ALREADY HAVE AN ACCOUNT? LOGIN
            </Button>
          </div>
        </Card.Body>
      </Card>
    </Container>
  );
}
